<template
  ><v-expansion-panel @click="toggleLayer">
    <v-expansion-panel-header>
      <template v-slot:default="{ open }">
        <v-checkbox
          :value="open"
          :input-value="open"
          label="Waves"
          class="menu-checkbox"
        ></v-checkbox>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-select label="Datetime" :items="waves_dates" v-model="active_date">
        <v-icon
          slot="prepend"
          :disabled="disableNextButton"
          @click="nextDate(active_date, waves_dates)"
          >mdi-menu-left</v-icon
        >
        <v-icon
          slot="append-outer"
          :disabled="disablePreviousButton"
          @click="previousDate(active_date, waves_dates)"
          >mdi-menu-right</v-icon
        >
      </v-select>
      <p>
        The operational global ocean analysis and forecast system of
        Météo-France with a resolution of 1/12 degree is providing daily
        analysis and 5 days forecasts for the global ocean sea surface waves.
        This product includes 3-hourly instantaneous fields of integrated wave
        parameters from the total spectrum (significant height, period,
        direction, Stokes drift,...etc), The global wave system of Météo-France
        is based on the wave model MFWAM which is a third generation wave model.
      </p>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import MapServices from "@/services/mapbox.service";

export default {
  name: "wavesExpansionPanel",
  data: () => ({
    layer_active: false,
    active_date: "2020-12-10",
    waves_dates: [
      "2020-12-10",
      "2020-12-09",
      "2020-12-08",
      "2020-12-07",
      "2020-12-06",
      "2020-12-05",
      "2020-12-04",
      "2020-12-03",
      "2020-12-02",
      "2020-12-01",
      "2020-11-30",
      "2020-11-29",
      "2020-11-28",
      "2020-11-27",
      "2020-11-26",
      "2020-11-25",
      "2020-11-24",
      "2020-11-23",
      "2020-11-22",
      "2020-11-21",
      "2020-11-20",
      "2020-11-19",
      "2020-11-18",
      "2020-11-17",
      "2020-11-16",
      "2020-11-15",
      "2020-11-14",
      "2020-11-13",
      "2020-11-12",
      "2020-11-11",
      "2020-11-10",
      "2020-11-09",
      "2020-11-08",
      "2020-11-07",
      "2020-11-06",
      "2020-11-05",
      "2020-11-04",
      "2020-11-03",
      "2020-11-02",
      "2020-11-01"
    ],
    waves_added: []
  }),
  computed: {
    disableNextButton() {
      return (
        this.waves_dates.indexOf(this.active_date) ===
        this.waves_dates.length - 1
      );
    },
    disablePreviousButton() {
      return this.waves_dates.indexOf(this.active_date) === 0;
    },
    layerName() {
      return `waves_${this.active_date}_layer`;
    }
  },
  methods: {
    toggleLayer() {
      if (this.layer_active) {
        MapServices.removeLayer(this.layerName);
        this.layer_active = false;
      } else {
        MapServices.loadAddWaveLayer(this.active_date);
        this.layer_active = true;
      }
    },
    nextDate(selectedElement, selection) {
      const selectedPeriodIndex = selection.indexOf(selectedElement);
      if (selectedPeriodIndex < selection.length - 1) {
        this.active_date = selection[selectedPeriodIndex + 1];
      }
    },
    previousDate(selectedElement, selection) {
      const selectedPeriodIndex = selection.indexOf(selectedElement);
      if (selectedPeriodIndex > 0) {
        this.active_date = selection[selectedPeriodIndex - 1];
      }
    }
  },
  watch: {
    active_date(date_string, old_date) {
      MapServices.removeLayer(`waves_${old_date}_layer`);
      MapServices.loadAddWaveLayer(date_string);
    }
  }
};
</script>

<style scoped>
.menu-checkbox {
  height: 30px;
  padding: 0;
  margin: auto 0;
}
</style>
